import { parse } from 'querystring';

import { Order } from '../../meta/types/billing/order';
import { PaymentType } from '../../meta/types/billing/payment';
import {
  BILLING_PLAN_MANAGEMENT_OFFER,
  SalesPackage,
  PaymentStrategy,
  SalesPackageSelector,
} from '../../meta/types/billing/salespackage';
import { CONFIG } from '../../meta/types/config';
import { formatNumber } from '../ui';

export const MANAGEMENT_OFFER_QUERY_STRING = 'management-offer';
export const PAYPAL_ENV = CONFIG.paypalEnv || 'sandbox';

export function getActiveSalesPackageFromLocation(
  location = window.location,
): SalesPackageSelector | undefined {
  const search = location.href.split('?')[1];
  const queryPlan = parse(search).plan;
  return queryPlan
    ? {
        salesPackageId:
          queryPlan === MANAGEMENT_OFFER_QUERY_STRING
            ? BILLING_PLAN_MANAGEMENT_OFFER
            : Array.isArray(queryPlan)
            ? queryPlan[0]
            : queryPlan,
        paymentStrategyId: 0,
      }
    : undefined;
}

export const existingOrderToSubscriptionPlan = (offer: Order): SalesPackage => {
  const paymentStrategy: PaymentStrategy = {
    id: 0,
    netAmount: offer.data.netAmount,
    paymentFrequencyType: offer.data.paymentFrequencyType,
    paymentFrequency: offer.data.paymentFrequency,
    paymentOptions: offer.data.paymentOptions || [],
  };
  if (offer.data.payPalAgreementPlanId) {
    paymentStrategy.payPalPlanId = offer.data.payPalAgreementPlanId;
  }
  const subscriptionPlan: SalesPackage = {
    name: offer.data.name,
    description: offer.data.description,
    paymentStrategies: [paymentStrategy],
    id: 0,
    planId: BILLING_PLAN_MANAGEMENT_OFFER,
    shortName: offer.data.name,
    displayRow: 0,
    purchaseAction: 'Upgrade',
    offer,
  };

  return subscriptionPlan;
};

const PERIOD_PATTERN = /^P([0-9]+).*$/;

function paymentFrequencyText(period?: string): string {
  if (!period) {
    return '';
  }
  const match = period.match(PERIOD_PATTERN);
  if (!match) {
    return '/month';
  }
  const months = parseInt(match[1], 10);

  return months <= 1 ? '/month' : `/${months} months`;
}

export function periodToHumanReadableText(period?: string): string {
  if (!period) {
    return 'Single';
  }
  const match = period.match(PERIOD_PATTERN);
  if (!match) {
    return 'Single';
  }
  const months = parseInt(match[1], 10);

  switch (months) {
    case 1:
      return 'Monthly';
    case 3:
      return 'Quarterly';
    case 6:
      return 'Half-yearly';
    case 12:
      return 'Yearly';
    default:
      return `/${months} months`;
  }
}

export function formattedPaymentAmount(
  value: number,
  isRecurring: boolean,
  period?: string,
): string {
  const netAmount = `€${formatNumber(value, 2, true)}`;
  return isRecurring ? `${netAmount}${paymentFrequencyText(period)}` : netAmount;
}

export function supportsPaymentOption(
  paymentPlan: PaymentStrategy | undefined,
  orderPaymentOptions: PaymentType[] | undefined,
  paymentType: PaymentType,
): boolean {
  const subscriptionPlanOptions = paymentPlan ? paymentPlan.paymentOptions : [];
  return (
    subscriptionPlanOptions.includes(paymentType) &&
    (orderPaymentOptions ? orderPaymentOptions.includes(paymentType) : true)
  );
}
